// import axios from 'axios'
import axios from "../api/axiosClient";

export function setAuthHeader(token) {
     axios.defaults.headers.common['Authorization'] = token ? 'Bearer ' + token : ''
}
